'use client'

import * as React from 'react'
import { cn } from '../../helpers/index.js'
import Button from '../../components/button.js'
import { Text } from '../../components/text.js'
import { Heading } from '../../components/index.js'

export interface PriceAndActionsProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 当前价格 */
  currentPrice: string
  /** 原价 */
  originalPrice?: string
  /** Learn More 按钮文本 */
  learnMoreText?: string
  /** Shop Now 按钮文本 */
  shopNowText?: string
  /** Learn More 点击回调 */
  onLearnMore?: () => void
  /** Shop Now 点击回调 */
  onShopNow?: () => void
  availableForSale: boolean
  /** Learn More 按钮 loading 状态 */
  learnMoreLoading?: boolean
  /** Shop Now 按钮 loading 状态 */
  shopNowLoading?: boolean
  /** 埋点数据 - 产品标题 */
  trackingTitle?: string
  /** 埋点数据 - 产品描述 */
  trackingDescription?: string
  /** 埋点数据 - SKU */
  trackingSku?: string
}

/**
 * PriceAndActions - 价格和操作区域
 */
const PriceAndActions = React.forwardRef<HTMLDivElement, PriceAndActionsProps>(
  (
    {
      currentPrice,
      originalPrice,
      learnMoreText = 'Learn More',
      shopNowText = 'Shop Now',
      onLearnMore,
      onShopNow,
      availableForSale,
      learnMoreLoading,
      shopNowLoading,
      className,
      trackingTitle,
      trackingDescription,
      trackingSku,
    },
    ref
  ) => {
    return (
      <div ref={ref} className={cn('flex w-full flex-col justify-center gap-2', className)}>
        {/* 价格 */}

        <div className="flex w-full items-center gap-2">
          {availableForSale ? (
            <>
              <Heading size={2} className={cn('text-info-primary')}>
                {currentPrice}
              </Heading>
              {originalPrice && (
                <Heading size={2} className={cn('text-info-tertiary line-through')}>
                  {originalPrice}
                </Heading>
              )}
            </>
          ) : (
            <Text
              size={4}
              className={cn(
                'text-info-primary text-2xl leading-[1.2] tracking-[-0.48px]',
                'tablet:text-xl tablet:tracking-[-0.4px]'
              )}
            >
              Sold out
            </Text>
          )}
        </div>

        {/* 按钮组 */}
        <div className={cn('flex w-full items-center gap-3', 'tablet:gap-2')}>
          <Button
            variant="secondary"
            size="lg"
            onClick={onLearnMore}
            loading={learnMoreLoading}
            data-headless-type-name="BuyOneGetOneShelf#ProductCard"
            data-headless-title-desc-button={`${trackingTitle || ''}#${trackingDescription || ''}#${learnMoreText}`}
            data-headless-sku={trackingSku}
          >
            {learnMoreText}
          </Button>
          <Button
            variant="primary"
            size="lg"
            onClick={onShopNow}
            disabled={!availableForSale}
            loading={shopNowLoading}
            data-headless-type-name="BuyOneGetOneShelf#ProductCard"
            data-headless-title-desc-button={`${trackingTitle || ''}#${trackingDescription || ''}#${shopNowText}`}
            data-headless-sku={trackingSku}
          >
            {shopNowText}
          </Button>
        </div>
      </div>
    )
  }
)

PriceAndActions.displayName = 'PriceAndActions'

export default PriceAndActions
